import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSpeciesContent, GetSpeciesContentResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<GetSpeciesContentResponse, GetSpeciesContentResponse>) => response?.data?.content;
const getError = (response?: SWRResponse<GetSpeciesContentResponse, GetSpeciesContentResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetSpeciesContentResponse, GetSpeciesContentResponse>) => ({});

const useGetSpeciesContent = (query?: Partial<GetSpeciesContent>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSpeciesContent(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSpeciesContent;